import { useEffect, useState } from "react"

export const BalanceBeginingDay = ({ statics, balance }: any) => {
    let [percent, setPercent] = useState<number>(0)

    useEffect(() => {
        if (statics) {
            let avg = statics?.first_balance_of_day?.current - balance;
            setPercent(Math.abs(avg / 100) + 10)
        }
    }, [statics])

    return (
        <>
            <div className="md:w-[30%] w-full md:pr-2 pr-0 md:mt-0 mt-2">
                <div className="w-full min-h-[86px] p-2 flex flex-col items-center rounded-md bg-trade-50">
                    <span className="text-sm text-white">بالانس ابتدای روز</span>
                    <div className="w-full  flex items-center justify-between md:mt-4 mt-1  mb-4 relative">
                        <div className="w-[70px] flex items-center justify-center text-sm text-green-600">{statics?.first_balance_of_day?.target.toFixed(0)} $</div>
                        <span></span>
                        <div className="w-[calc(100%-140px)] h-[10px] rounded-full bg-trade-25 flex items-center relative  mt-0 ">
                            <div className="w-[calc(50%-5px)] h-[10px] flex items-center justify-end  overflow-hidden ">
                                {statics?.first_balance_of_day?.current > balance &&
                                    <div className="  bg-[#2563eb] h-[10px] shadow rounded-r-full" style={{ width: `${percent}%` }}></div>
                                }
                            </div>
                            <div className=" w-[10px] h-[10px] bg-orange-600  " />
                            <div className="w-[calc(50%-5px)] h-[10px] flex items-center overflow-hidden">
                                {statics?.first_balance_of_day?.current < balance &&
                                    <div className="  bg-[#2563eb] h-[10px] shadow rounded-l-full" style={{ width: `${percent}%` }}></div>
                                }
                            </div>
                            <span className="absolute text-xs text-white top-4 right-[calc(50%-10px)]">{statics?.first_balance_of_day?.current.toFixed(0)}</span>
                        </div>
                        <div className="w-[70px] flex items-center justify-center text-sm text-red-500">{statics?.first_balance_of_day?.drawdown.toFixed(0)} $</div>
                    </div>
                </div>
            </div>
        </>
    )
}